import type { ReactNode } from 'react';

export interface TopBarProps {
  /** Opens central search (Cmd+K) — wired by module 0.8; a trigger here. */
  onOpenSearch?: () => void;
  /** Primary actions area (kept minimal — plan §3.2). */
  actions?: ReactNode;
  /**
   * Callback ref to the actions container so the active module can portal its
   * own primary actions onto the search line (replit.md L14 — one shared shell;
   * the cash-flow lenses keep their actions identical by sharing this slot).
   */
  actionsRef?: (el: HTMLDivElement | null) => void;
}

/**
 * The single thin top bar (plan §3.2, docs/UI_STANDARDS.md §3): a Cmd+K search
 * trigger plus a few primary actions. No other chrome is persistent so the
 * content area (the calendar) keeps maximum space.
 */
export function TopBar({ onOpenSearch, actions, actionsRef }: TopBarProps): ReactNode {
  return (
    <header className="flex h-12 shrink-0 items-center gap-3 border-b border-border bg-card px-3">
      <span className="text-sm font-semibold tracking-tight text-foreground">Progear Finance</span>
      <button
        type="button"
        className="ml-2 flex h-8 min-w-0 max-w-xl flex-1 items-center gap-2 rounded-md border border-border bg-background px-3 text-xs text-muted-foreground transition-colors hover:bg-accent"
        aria-label="Otsing"
        onClick={onOpenSearch}
      >
        <span aria-hidden="true" className="shrink-0 text-[13px] leading-none">⌕</span>
        <span className="truncate whitespace-nowrap">Otsi: tarnija, klient, arve nr, PR-XXX, projekt…</span>
        <kbd className="ml-auto shrink-0 rounded bg-muted px-1.5 py-0.5 text-[10px]">⌘K</kbd>
      </button>
      <div ref={actionsRef} className="ml-auto flex items-center gap-2">{actions}</div>
    </header>
  );
}
